import { useState } from 'react';
import { Auth, API } from 'aws-amplify';

const useApi = () => {
    const [loadingApi, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const getHeaders = async () => {
        const session = await Auth.currentSession();
        const accessToken = session.getAccessToken().getJwtToken();
        return {
            Authorization: `Bearer ${accessToken}`,
        };
    }
    // Function to make POST API call
    const apiPost = async (apiName, route, body) => {
        setLoading(true);
        setError(null);

        try {
            // Get the session and access token
            const headers = await getHeaders();

            const response = await API.post(apiName, route, {
                body: body,
                headers: headers,
            });

            setLoading(false);
            return response;
        } catch (err) {
            setLoading(false);
            setError(err);
            console.error("API call failed:", err);
            throw err; // Rethrow to handle outside the hook if needed
        }
    };
    

    // Function to make GET API call
    const apiGet = async (apiName, route, queryParams) => {
        setLoading(true);
        setError(null);
        try {
            const headers = await getHeaders();
            const response = await API.get(apiName, route, {
                headers: headers,
                queryStringParameters: queryParams,
            });
            setLoading(false);
            return response;
        } catch (err) {
            setLoading(false);
            setError(err);
            console.error("API call ss failed:", err);
            //throw err;
        }
    };
    const apiDelete = async (apiName, route, payload) => {
        try {
            const headers = await getHeaders();
                               
            const response = await API.del(apiName, route, {
                headers: headers,
                queryStringParameters: payload
            });
            
            return response;
            
        } catch (error) {
            console.error('Error in apiDelete:', error);
            throw error; // Re-throw to handle in the component
        }
    };
    return { apiPost, apiGet, apiDelete, loadingApi, error };
};


export default useApi;
